/**
 * Utility to group conversations by time bucket
 *
 * @param {Array} conversations  The conversations to group
 * @returns {Object}  The grouped conversations
 */
export function groupConversationsByTime(conversations) {
  const now = new Date()
  const startOfToday = new Date(now)
  startOfToday.setHours(0, 0, 0, 0)
  const startOfYesterday = new Date(startOfToday)
  startOfYesterday.setDate(startOfToday.getDate() - 1)
  const startOf7DaysAgo = new Date(startOfToday)
  startOf7DaysAgo.setDate(startOfToday.getDate() - 7)
  const startOf14DaysAgo = new Date(startOfToday)
  startOf14DaysAgo.setDate(startOfToday.getDate() - 14)
  const startOf30DaysAgo = new Date(startOfToday)
  startOf30DaysAgo.setDate(startOfToday.getDate() - 30)

  const buckets = {
    'Last Hour': [],
    Today: [],
    Yesterday: [],
    'Previous 7 Days': [],
    'Previous 14 Days': [],
    'Previous 30 Days': [],
  }

  conversations.forEach(conv => {
    const updated = new Date(conv.updated_at)
    const diffMs = now - updated
    const diffHours = diffMs / (1000 * 60 * 60)

    if (diffHours < 1) {
      buckets['Last Hour'].push(conv)
    } else if (updated >= startOfToday) {
      buckets['Today'].push(conv)
    } else if (updated >= startOfYesterday && updated < startOfToday) {
      buckets['Yesterday'].push(conv)
    } else if (updated >= startOf7DaysAgo && updated < startOfYesterday) {
      buckets['Previous 7 Days'].push(conv)
    } else if (updated >= startOf14DaysAgo && updated < startOf7DaysAgo) {
      buckets['Previous 14 Days'].push(conv)
    } else if (updated >= startOf30DaysAgo && updated < startOf14DaysAgo) {
      buckets['Previous 30 Days'].push(conv)
    } else {
      // For conversations older than 30 days, bucket by month
      const monthYear = updated.toLocaleString('default', {
        month: 'long',
        year: 'numeric',
      })
      if (!buckets[monthYear]) {
        buckets[monthYear] = []
      }
      buckets[monthYear].push(conv)
    }
  })
  return buckets
}
